import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "main-footer",
    data() {
        return {
            showPhonesList: false,
            currentBranch: "",
            selectBranch: "",
        };
    },
    computed: {
        ...mapGetters({
            showCatalogMenu: "system/showCatalogMenu",
            contact: "contacts/contacts",
            list: "setting/menu",
            listLoading: "setting/menuLoading",
            aboutList: "about/aboutList",
            // currentBranch: 'branches/currentBranch',
            branches: "branches/branchesList",
        }),
    },
    created() {},
    watch: {
        branches() {
            let branches = JSON.parse(localStorage.getItem("branchId"));
            if (branches) {
                Array.from(this.branches).forEach(branch => {
                    if (parseInt(branch.id) === parseInt(branches.id)) {
                        this.selectBranch = branch;
                    }
                });
            }
        },
    },
    mounted() {},
    methods: {
        ...mapMutations({
            changeShowCatalogMenu: `system/CHANGE_SHOW_CATALOG_MENU`,
        }),
        ...mapActions({
            fetchBranches: "branches/GET_BRANCHES",
        }),
        chechIsAnchorExist(selector) {
            return !!document.querySelector(selector);
        },
        changeHeaderCatalog() {
            if (this.showCatalogMenu) {
                this.changeShowCatalogMenu(false);
            }
        },
        getContactSocialItem(item) {
            return this.contact.data[item];
        },
        hidePhonesList() {
            this.showPhonesList = false;
        },
        changeFooter() {
            if (this.$route.name === "home") {
                window.scrollTo({ top: 0, behavior: "smooth" });
            } else {
                this.$router.push({ name: "home" }).catch(() => {
                    console.log();
                });
            }
        },
    },
};
